import { useEffect } from 'react';
import { RouteChildrenProps } from 'react-router';
import { useBackButtonReducer, useMenuBarReducer } from 'src/pages/consumer/components/DishFirstHeader/store';
import { useDispatch } from 'src/store';
import { actions } from 'src/store/navbar';

export type UseNavigationProps = {
  foodPreferenceSelected?: boolean;
  isOnSeeAllPage?: boolean;
  location?: RouteChildrenProps['location'];
};

export const useNavigation = (props: UseNavigationProps) => {
  const { foodPreferenceSelected = false, isOnSeeAllPage = false, location } = props;

  const dispatch = useDispatch();
  const { isShowing: isBackButtonShowing, show: showBackButton } = useBackButtonReducer();
  const { isShowing: isShowingMenuBar, hide: hideMenuBar } = useMenuBarReducer();

  useEffect(() => {
    dispatch(actions.resetState({ hideBackButton: !isOnSeeAllPage }));

    if ((!isBackButtonShowing && isOnSeeAllPage) || foodPreferenceSelected) {
      showBackButton();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- missing deps to prevent infinite loop
  }, [isOnSeeAllPage, foodPreferenceSelected]);

  useEffect(() => {
    if (isShowingMenuBar) {
      hideMenuBar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- missing deps to prevent infinite loop
  }, [location, isShowingMenuBar]);
};
